const CardType = {
  ID_CARD: "1", //"身份证"
  BANK_CARD: "2", //"银行卡"
  MEDICARE_CARD: "3", //"社保卡"
  ELECTRONIC_HEALTH_CARD: "4", //"电子健康卡"
  MEDICAL_CARD: "5", //"诊疗卡"
}

const AccountType = {
  OUT_PATIENT: '0',
  IN_HOSPITAL: '1'
}

const TermInfo = {
  termNo: 'ol001',
  termType: '10'
}

const CardTypeDesc = [
  '身份证', '银行卡', '社保卡', '电子健康卡', '诊疗卡'
]
export default {
  CardType,
  AccountType,
  CardTypeDesc,
  TermInfo
}